<template>
  <div class="save-filters__modal">
    <modal
      :active="true"
      :primary-button-disabled="isLoading || isSaving || hasLengthError"
      :primary-button-loading="isSaving"
      tertiary-button-label="Cancel"
      primary-button-label="Confirm"
      size="small"
      @onClose="onClose()"
      @onConfirm="onSave()">
      <template #header>
        <p>Save Filter</p>
      </template>
      <template #content>
        <div v-if="isFilterUpdate" class="save-filters__modal__body">
          <LoadingIndicator
            v-if="isLoading"
            label="Fetching applied filters..."
            :loading="isLoading" />
          <form-select
            v-else
            :options="savedFilters"
            :value="selectedExistingFilter ? selectedExistingFilter.value : ''"
            :error="hasValidationError"
            :error-message="
              hasValidationError ? 'Select a filter to apply' : ''
            "
            label="Modify saved filter"
            @input="handleFilterChange($event)" />
          <div class="save-filters__modal__body__switch-view">
            <a @click.prevent="handleIsUpdate(false)">Create new filter</a>
          </div>
        </div>
        <div v-else class="save-filters__modal__body">
          <text-input
            id="saveFilter-search-input"
            :show-clear-button="true"
            label="Filter name"
            placeholder="Provide a name for the filter"
            :error="hasValidationError || hasLengthError"
            :error-message="errorMessage"
            :value="selectedFilterName"
            @onChange="onInput($event)" />
          <div
            v-if="savedFilters.length"
            class="save-filters__modal__body__switch-view">
            <a @click.prevent="handleIsUpdate(true)">Update saved filter</a>
          </div>
        </div>
      </template>
    </modal>
  </div>
</template>

<script>
export default {
  name: "SaveNewFilterModal",
  props: {
    savedFilters: { type: Array, default: () => {} },
    isUpdate: { type: Boolean, default: true },
    currentFilter: { type: String, default: "" },
    isLoading: { type: Boolean, default: true },
  },
  data() {
    const existingFilter = this.savedFilters.find(
      (filter) => filter.filter_title === this.currentFilter
    );

    return {
      selectedFilterName: "",
      selectedExistingFilter: this.savedFilters?.length
        ? existingFilter || this.savedFilters[0]
        : null,
      isFilterUpdate: this.isUpdate,
      hasValidationError: false,
      hasLengthError: false,
      isSaving: false,
    };
  },
  computed: {
    saveLabel() {
      return this.isSaving ? "Saving..." : "Save";
    },
    errorMessage() {
      return this.hasValidationError
        ? "Provide a name for filter"
        : "" || this.hasLengthError
        ? "Provide filter name with less than 50 characters"
        : "";
    },
  },
  watch: {
    isUpdate(val) {
      this.isFilterUpdate = val;
    },
    savedFilters(newFilters) {
      const existingFilter = newFilters.find(
        (filter) => filter.filter_title === this.currentFilter
      );
      this.selectedExistingFilter = newFilters?.length
        ? existingFilter || newFilters[0]
        : null;
    },
  },
  methods: {
    onClose() {
      this.$emit("onModalClose");
    },
    onInput({ target: { value } }) {
      const selectedFilterName = value.trim();
      if (selectedFilterName.length >= 50) {
        this.hasLengthError = true;
      } else {
        this.hasLengthError = false;
      }
      this.selectedFilterName = selectedFilterName;
    },
    handleFilterChange(selectedFilter) {
      this.selectedExistingFilter = selectedFilter;
      this.hasValidationError = false;
    },
    handleIsUpdate(status) {
      this.isFilterUpdate = status;
      this.hasValidationError = false;
    },
    onSaveCB(isSuccess) {
      if (isSuccess) {
        this.$parent.onSaveNewFilterSuccess();
      } else {
        this.isSaving = false;
      }
    },
    onSave() {
      if (this.isFilterUpdate) {
        if (this.selectedExistingFilter) {
          this.hasValidationError = false;
          this.isSaving = true;
          this.$parent.$emit(
            "onSaveNewFilter",
            this.selectedExistingFilter.value,
            this.isFilterUpdate,
            this.onSaveCB
          );
        } else {
          this.hasValidationError = true;
        }
      } else {
        if (this.selectedFilterName) {
          this.hasValidationError = false;
          this.isSaving = true;
          this.$parent.$emit(
            "onSaveNewFilter",
            this.selectedFilterName,
            this.isFilterUpdate,
            this.onSaveCB
          );
        } else {
          this.hasValidationError = true;
        }
      }
    },
  },
};
</script>

<style lang="scss">
@import "@/styles/imports";

.save-filters__modal {
  & .modal--small {
    height: 300px;
  }
  &__body {
    &__switch-view {
      justify-content: flex-end;
      display: flex;
      & a {
        font-size: 14px;
        margin-top: 16px;
        color: var(--Blue-600-Dark);
        cursor: pointer;
      }
    }
  }
}
</style>
